import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * 오늘 지면(TODAY) 데이터를 다시 받아오게 한다.
 *
 * 네이티브의 `refreshToday` 브릿지에 대응한다. 콘텐츠가 취향 설정 등으로 오늘 지면 결과를
 * 바꾼 뒤 갱신을 요청할 때 호출된다.
 *
 * 오늘 지면은 **RN 렌더**(`TodayAtomic`)라 호스트의 react-query 캐시를 무효화하면 그대로
 * 다시 그려진다. iframe 이 아니므로 URL 을 바꿔 문서를 다시 로드할 필요가 없다.
 */

/** 지면 본체. `useGetScreensInfiniteQuery` 가 만드는 키의 앞부분. */
const TODAY_SCREEN_QUERY_KEY = ['getScreens', { screen_name: 'TODAY' }];

/** 지면 안 개별 컴포넌트들. `queryKey.screenComponent(...)` 가 만드는 키의 앞 2개. */
const TODAY_SCREEN_COMPONENT_QUERY_KEY = ['atomicScreenComponent', 'TODAY'];

export const useRefreshToday = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    // ⚠️ `exact` 를 쓰면 안 된다. 두 키 모두 뒤쪽이 가변값이다 —
    // `getScreens` 는 객체 안에 nextToken·필터 값이 함께 들어가고(부분 비교로 매칭된다),
    // `atomicScreenComponent` 는 componentId 이하가 붙는다(prefix 로 매칭된다).
    queryClient.invalidateQueries({ queryKey: TODAY_SCREEN_QUERY_KEY });
    queryClient.invalidateQueries({
      queryKey: TODAY_SCREEN_COMPONENT_QUERY_KEY,
    });
  }, [queryClient]);
};
